const DotLoading = () => (
  <span className="ico_loading" aria-label="로딩중">
    <span></span>
    <span></span>
    <span></span>
  </span>
);

export default DotLoading;
